/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */


jQuery(document).ready(function ($) {




    /**
     * 
     * PAGINA LISTA OGGETTI PROPOSTI
     * 
     * 
     * 
     */
    $('#table-lista-oggetti-proposti').DataTable({
        responsive: true,
        "columns": [
            {"data": "Posizione"},
            {"data": "Nome Utente"},
            {"data": "Nome Oggetto"},
            {"data": "Descrizione Oggetto"},
            {"data": "Data Proposta"},
            {"data": "Azione"}

        ],
        "oLanguage": {
            "sLengthMenu": "Mostra _MENU_ risultati per pagina",
            "sZeroRecords": "Nessun oggetto trovato",
            "sInfo": "Visualizzati Oggetti da _START_ a _END_ di _TOTAL_ risultati",
            "sInfoEmpty": "Mostra 0 su 0 di 0 risultati",
            "sInfoFiltered": "(Filtrati da _MAX_ risultati totali)",
            "sSearch": "Filtra:",
            "oPaginate": {
                "sFirst": "|<",
                "sLast": ">|",
                "sNext": ">",
                "sPrevious": "<"
            }
        },
        "aoColumnDefs": [{"bSortable": false, "aTargets": [5]}]
    });
    
    
    $(document).on('click', '.button-accetta-oggetto', function () {
        var id_annuncio = $(this).data('idannuncio');
        var id_oggetto = this.value;
        
        $('#messageAccettaOggetto').html('');
        $("#messageAccettaOggetto").removeClass('alert-danger');
        $("#messageAccettaOggetto").removeClass('alert-success');
        $("#messageAccettaOggetto").hide();
        var faiAjax = true;
        var button = this;
        if (faiAjax)
        {
            var r = confirm("Sei sicuro di volere accettare questo oggetto?");
            if (r == true) {
                themeSpinner('show');
                $.ajax({//create an ajax request to load_page.php
                    type: "POST",
                    cache: false,
                    url: ajax_url,
                    data:
                            {
                                action: 'accetta_oggetto_action',
                                id_oggetto: id_oggetto,
                                id_annuncio: id_annuncio

                            },
                    dataType: "html", //expect html to be returned                
                    success: function (response) {
                        if (response === '1')
                        {
                            reloadScrollingToTitle();
                        }
                        else
                        {
                            $("#messageAccettaOggetto").html(response);
                            $("#messageAccettaOggetto").addClass('alert-danger');
                            $("#messageAccettaOggetto").show();
                        }
                        themeSpinner('hide');


                    },
                    error: function () {
                        themeSpinner('hide');
                        $("#messageAccettaOggetto").html('Si sono verificati dei problemi nell\'assegnazione dell\' oggetto');
                        $("#messageAccettaOggetto").addClass('alert-danger');
                        $("#messageAccettaOggetto").show();
                    }

                });
            }
        }
    });
    $(document).on('click', '.button-oggetto-recuperato', function () {
        var id_annuncio = $(this).data('idannuncio');
        var id_oggetto = this.value;
        
        $('#messageAccettaOggetto').html('');
        $("#messageAccettaOggetto").removeClass('alert-danger');
        $("#messageAccettaOggetto").removeClass('alert-success');
        $("#messageAccettaOggetto").hide();
        var faiAjax = true;
        var button = this;
        if (faiAjax)
        {
            var r = confirm("Confermi di avere ritirato l'oggetto?");
            if (r == true) {
                themeSpinner('show');
                $.ajax({//create an ajax request to load_page.php
                    type: "POST",
                    cache: false,
                    url: ajax_url,
                    data:
                            {
                                action: 'recupero_oggetto_action',
                                id_oggetto: id_oggetto,
                                id_annuncio: id_annuncio

                            },
                    dataType: "html", //expect html to be returned                
                    success: function (response) {
                        if (response === '1')
                        {
                            reloadScrollingToTitle();
                        }
                        else
                        {
                            $("#messageAccettaOggetto").html(response);
                            $("#messageAccettaOggetto").addClass('alert-danger');
                            $("#messageAccettaOggetto").show();
                        }
                        themeSpinner('hide');


                    },
                    error: function () {
                        themeSpinner('hide');
                        $("#messageAccettaOggetto").html('Si sono verificati dei problemi nel marcare l\'oggetto come ritirato. Per favore, riprova');
                        $("#messageAccettaOggetto").addClass('alert-danger');
                        $("#messageAccettaOggetto").show();
                    }

                });
            }
        }
    });
    $(document).on('click', '.button-oggetto-non-recuperato', function () {
        var id_annuncio = $(this).data('idannuncio');
        var id_oggetto = this.value;
        
        $('#messageAccettaOggetto').html('');
        $("#messageAccettaOggetto").removeClass('alert-danger');
        $("#messageAccettaOggetto").removeClass('alert-success');
        $("#messageAccettaOggetto").hide();
        var faiAjax = true;
        var button = this;
        if (faiAjax)
        {
            var r = confirm("Confermi di non essere più interessato all'oggetto accettato? In caso affermativo, altri utenti potranno proporti i loro oggetti");
            if (r == true) {
                themeSpinner('show');
                $.ajax({//create an ajax request to load_page.php
                    type: "POST",
                    cache: false,
                    url: ajax_url,
                    data:
                            {
                                action: 'non_recupero_oggetto_action',
                                id_oggetto: id_oggetto,
                                id_annuncio: id_annuncio

                            },
                    dataType: "html", //expect html to be returned                
                    success: function (response) {
                        if (response === '1')
                        {
                            reloadScrollingToTitle();
                        }
                        else
                        {
                            $("#messageAccettaOggetto").html(response);
                            $("#messageAccettaOggetto").addClass('alert-danger');
                            $("#messageAccettaOggetto").show();
                        }
                        themeSpinner('hide');


                    },
                    error: function () {
                        themeSpinner('hide');
                        $("#messageAccettaOggetto").html('Si sono verificati dei problemi nel marcare l\'oggetto come non ritirabile da te. Per favore, riprova');
                        $("#messageAccettaOggetto").addClass('alert-danger');
                        $("#messageAccettaOggetto").show();
                    }

                });
            }
        }
    });

});